import { render, staticRenderFns } from "./PurchasedKit.vue?vue&type=template&id=4c68fd8e&"
import script from "./PurchasedKit.vue?vue&type=script&lang=js&"
export * from "./PurchasedKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports